import { createClient } from '@/shared/api';
import type {
  RefreshShipmentTrackingQuery,
  RefreshShipmentTrackingQueryVariables,
} from '@/shared/api';
import REFRESH_SHIPMENT_TRACKING_QUERY from '../queries/refreshShipmentTracking';

/**
 * Refreshes the carrier tracking details of an RMA shipment. Sends REFRESH_SHIPMENT_TRACKING_QUERY as a mutation and throws the returned message when isSuccess is false, otherwise returning the tracking payload.
 *
 * @param input - Mutation input payload.
 * @returns The refreshed shipment tracking payload.
 */
const fetchRefreshShipmentTracking = async (
  input: RefreshShipmentTrackingQueryVariables['input'],
): Promise<NonNullable<RefreshShipmentTrackingQuery['refreshShipmentTracking']>['tracking']> => {
  const client = createClient();
  const result = await client.mutate<
    RefreshShipmentTrackingQuery,
    RefreshShipmentTrackingQueryVariables
  >({
    mutation: REFRESH_SHIPMENT_TRACKING_QUERY,
    variables: {
      input,
    },
  });
  // client.mutate's default errorPolicy throws before this line on any GraphQL error, so data is always present here.
  const { isSuccess, message, tracking } = result.data!.refreshShipmentTracking!;
  if (!isSuccess) {
    throw new Error(message ?? undefined);
  }
  return tracking;
};

export default fetchRefreshShipmentTracking;
